/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Typographic_SoulInputs */

const en_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typographic Soul`)
};

const es_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alma tipográfica`)
};

const fr_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'Âme Typographique`)
};

const de_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typografische Seele`)
};

const ja_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイポグラフィの魂`)
};

const zh_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排版之魂`)
};

const ar_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`روح الطباعة والخطوط`)
};

const id_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jiwa Tipografi`)
};

const it_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anima Tipografica`)
};

const ru_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Типографика`)
};

const pt_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alma Tipográfica`)
};

const ko_typographic_soul = /** @type {(inputs: Typographic_SoulInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`타이포그래픽 소울`)
};

/**
* | output |
* | --- |
* | "Typographic Soul" |
*
* @param {Typographic_SoulInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const typographic_soul = /** @type {((inputs?: Typographic_SoulInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Typographic_SoulInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_typographic_soul(inputs)
	if (locale === "es") return es_typographic_soul(inputs)
	if (locale === "fr") return fr_typographic_soul(inputs)
	if (locale === "de") return de_typographic_soul(inputs)
	if (locale === "ja") return ja_typographic_soul(inputs)
	if (locale === "zh") return zh_typographic_soul(inputs)
	if (locale === "ar") return ar_typographic_soul(inputs)
	if (locale === "id") return id_typographic_soul(inputs)
	if (locale === "it") return it_typographic_soul(inputs)
	if (locale === "ru") return ru_typographic_soul(inputs)
	if (locale === "pt") return pt_typographic_soul(inputs)
	return ko_typographic_soul(inputs)
});